import { useCallback } from 'react';

import { useSystemConfig } from '#/features/system/system-config-context';
import { logEvent } from './logging/logging';

export function useBuildStarknetTxUrl() {
  const config = useSystemConfig();
  return useCallback(
    (txHash: string) => starknetTxUrl(config.starknet.explorerUrl, txHash),
    [config],
  );
}

export function useDebugStarknetTx() {
  const config = useSystemConfig();
  return useCallback(
    (txDescription: string, txHash: string) => {
      const txUrl = starknetTxUrl(config.starknet.explorerUrl, txHash);
      logEvent('Starknet Transaction', { txDescription, txUrl });
    },
    [config],
  );
}

export function useBuildStarknetContractUrl() {
  const config = useSystemConfig();
  return useCallback(
    (contractAddress: string) =>
      starknetContractUrl(config.starknet.explorerUrl, contractAddress),
    [config],
  );
}

function starknetTxUrl(explorerUrl: string, txHash: string): string {
  return `${explorerUrl}tx/${txHash}`;
}

function starknetContractUrl(
  explorerUrl: string,
  contractAddress: string,
): string {
  return `${explorerUrl}contract/${contractAddress}`;
}
